/******/ (() => { // webpackBootstrap
/*!**********************************************!*\
  !*** ./src/js/components/flip-categories.js ***!
  \**********************************************/
document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.flip-categories__tabs li');
  var tabContents = document.querySelectorAll('.flip-categories__tabs-content');
  var scrollContainers = document.querySelectorAll('.scroll-container');
  //const progressBars = document.querySelectorAll('.flip-progress-bar');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tabName = tab.getAttribute('aria-controls');
      if (!tabName) return;

      // Remove active class from all tabs and contents
      tabs.forEach(function (tab) {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
      });
      tabContents.forEach(function (content) {
        content.classList.remove('active');
      });

      // Add active class to the clicked tab and corresponding content
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      document.getElementById(tabName).classList.add('active');
    });
  });

  // Set the first tab as active
  tabs[0].click();

  // Function to update progress bar based on scroll position
  function updateProgressBar(container) {
    var progressBar = document.querySelector('.flip-progress-bar[data-progress-result="' + container.getAttribute('data-progress-result') + '"]');
    var scrollWidth = container.scrollWidth - container.clientWidth;
    var scrollLeft = container.scrollLeft;
    var progressResult = scrollLeft / scrollWidth * 100;

    // Ensure progress never goes below 20%
    progressBar.style.width = Math.max(progressResult, 20) + '%';
  }

  // Update progress bars on scroll
  scrollContainers.forEach(function (container) {
    container.addEventListener('scroll', function () {
      updateProgressBar(container);
    });

    // Initialize progress bar width to 20% on page load
    var progressBar = document.querySelector('.flip-progress-bar[data-progress-result="' + container.getAttribute('data-progress-result') + '"]');
    if (progressBar) {
      progressBar.style.width = '20%';
    }
  });
});
/******/ })()
;